module.exports = __webpack_public_path__ + "img/logo-sfg-w-600.3c43cf27.png";